const formatName = {
    install(Vue) {
        Vue.filter('formatName', (value) => {
            if (value) {
                const names = value.toLowerCase().split(' ')            
                return names.map(name => name = name.length > 1 ? name[0].toUpperCase() + name.slice(1) : name.toUpperCase()).join(' ')
            } else {
                return value
            }            
        });
    },
};

export default formatName